var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "vacation_period",
        "no-close-on-backdrop": true,
        size: "lg",
        title: "Редагувати період відпустки",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ ok, cancel }) {
            return [
              _vm.show_action
                ? _c("b-spinner", { attrs: { variant: "success" } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn btn-lg waves-effect waves-themed mr-3",
                  attrs: { size: "xl", variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.save()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fal fa-check mr-1" }),
                  _vm._v("\n            Зберегти\n        "),
                ]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "div",
        [
          _c("date-picker", {
            attrs: {
              "value-type": "format",
              lang: _vm.d_lang,
              range: "",
              shortcuts: _vm.shortcuts,
              confirm: "",
              "first-day-of-week": 1,
            },
            model: {
              value: _vm.form.time_range,
              callback: function ($$v) {
                _vm.$set(_vm.form, "time_range", $$v)
              },
              expression: "form.time_range",
            },
          }),
          _vm._v(" "),
          _c("b-form-valid-feedback", { attrs: { state: _vm.can_format } }, [
            _vm._v(
              "\n            терміном на " +
                _vm._s(_vm.diff_days) +
                " дні(в) в період з " +
                _vm._s(_vm._f("formatDate")(_vm.form.time_range[0])) +
                " по\n            " +
                _vm._s(_vm._f("formatDate")(_vm.form.time_range[1])) +
                "\n        "
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }